import React, { useState } from 'react';
import { LayoutDashboardIcon, InfoIcon, BarChartIcon, PackageIcon, FileTextIcon, UploadIcon, ChevronDown, ChevronRight } from 'lucide-react';
import { useCurrentRole } from '../demo/RoleSwitcher';
type Step = {
  id: number;
  name: string;
  component: React.ReactNode;
};
interface SidebarProps {
  steps: Step[];
  currentStep: number;
  setCurrentStep: (step: number) => void;
  selectedDashboard: string;
  setSelectedDashboard: (dashboard: string) => void;
}
const mgaDashboardItems = ['Executive Summary', 'Financial Performance', 'Loss Performance & Ratios', 'Capital & Return on Capital', 'Reinsurance & Retrocession', 'Exposure, Line Size & Accumulation', 'Portfolio Mix & Growth', 'Catastrophe Risk', 'Credit Control & Operations', 'Calendar', 'Compliance'];
const captiveDashboardItems = ['Portfolio Overview', 'Cell Performance', 'Underwriting & Pricing', 'Claims & Governance', 'Capital & Reinsurance', 'Governance Agent'];
export function Sidebar({
  steps,
  currentStep,
  setCurrentStep,
  selectedDashboard,
  setSelectedDashboard
}: SidebarProps) {
  const [isDashboardsOpen, setIsDashboardsOpen] = useState(true);
  const role = useCurrentRole();
  const dashboardSubItems = role === 'captive_manager' ? captiveDashboardItems : mgaDashboardItems;
  const icons = [<InfoIcon size={18} data-id="element-2177" />, <BarChartIcon size={18} data-id="element-2178" />, <PackageIcon size={18} data-id="element-2179" />, <FileTextIcon size={18} data-id="element-2180" />, <UploadIcon size={18} data-id="element-2181" />, <LayoutDashboardIcon size={18} data-id="element-2182" />];
  const handleDashboardClick = (dashboardName: string) => {
    setSelectedDashboard(dashboardName);
    const dashboardStepIndex = steps.findIndex(step => step.name === 'Dashboard');
    if (dashboardStepIndex !== -1) {
      setCurrentStep(dashboardStepIndex);
    }
  };
  return <aside className="w-64 bg-white border-r border-neutral-200 hidden md:block" data-id="element-2183">
      <nav className="mt-6 px-4" data-id="element-2184">
        <ul className="space-y-1" data-id="element-2185">
          {steps.map((step, index) => {
          if (step.name === 'Dashboard') {
            return <li key={step.id} data-id="element-2186">
                  <button onClick={() => {
                setIsDashboardsOpen(!isDashboardsOpen);
                setCurrentStep(index);
              }} className={`flex items-center justify-between w-full px-3 py-2.5 text-left rounded-md transition-colors ${currentStep === index ? 'bg-pink-50 text-pink-600' : 'text-neutral-700 hover:bg-neutral-50'}`} data-id="element-2187">
                    <div className="flex items-center gap-3 text-sm font-medium" data-id="element-2188">
                      <span className={currentStep === index ? 'text-pink-500' : 'text-neutral-400'} data-id="element-2189">
                        {icons[index]}
                      </span>
                      <span data-id="element-2190">Dashboards</span>
                    </div>
                    <span className={currentStep === index ? 'text-pink-400' : 'text-neutral-400'} data-id="element-2191">
                      {isDashboardsOpen ? <ChevronDown size={16} data-id="element-2192" /> : <ChevronRight size={16} data-id="element-2193" />}
                    </span>
                  </button>

                  {isDashboardsOpen && <ul className="mt-1 ml-3 border-l border-neutral-200 space-y-0.5" data-id="element-2194">
                      {dashboardSubItems.map(subItem => <li key={subItem} data-id="element-2195">
                          <button onClick={() => handleDashboardClick(subItem)} className={`flex items-center w-full pl-6 pr-3 py-2 text-left text-sm rounded-r-md transition-colors ${selectedDashboard === subItem ? 'bg-pink-50 text-pink-600 font-medium border-l-2 border-pink-500 -ml-px' : 'text-neutral-600 hover:bg-neutral-50 hover:text-neutral-900'}`} data-id="element-2196">
                            {subItem}
                          </button>
                        </li>)}
                    </ul>}
                </li>;
          }
          return <li key={step.id} data-id="element-2197">
                <button onClick={() => setCurrentStep(index)} className={`flex items-center gap-3 w-full px-3 py-2.5 text-left rounded-md transition-colors text-sm font-medium ${currentStep === index ? 'bg-pink-50 text-pink-600' : 'text-neutral-700 hover:bg-neutral-50'}`} data-id="element-2198">
                  <span className={currentStep === index ? 'text-pink-500' : 'text-neutral-400'} data-id="element-2199">
                    {icons[index]}
                  </span>
                  <span data-id="element-2200">{step.name}</span>
                </button>
              </li>;
        })}
        </ul>
      </nav>
    </aside>;
}